function homeRefresh() {
  window.location.href = '/';
  window.location.reload();
}

export default homeRefresh;
